import { report } from './index';
export function buryingPoint (title, axios) {
	let itemid = ''
	if (['新手', '注册', '新兵', '新进', '新萌', '不删档新手', '不删档注册', '不删档新兵', '不删档新进',
		'不删档新萌', '公测新手', '公测注册', '公测新兵', '公测新进', '公测新萌'].indexOf(title) >= 0) {
		itemid = '12007'
	} else if (['等级', '不删档等级', '公测等级'].indexOf(title) >= 0) {
		itemid = '12008'
	} else if (['战力', '不删档战力', '公测战力'].indexOf(title) >= 0) {
		itemid = '12009'
	} else if (['元', '日充值', '周充值', '月充值', '充值', '每日充值', '每周充值', '每月充值', '不删档充值', '不删档日充值',
		'不删档周充值', '不删档月充值', '公测充值', '公测日充值', '公测周充值', '公测月充值'].indexOf(title) >= 0) {
		itemid = '12010'
	} else if (['日礼包', '周礼包', '月礼包', '日福利', '周福利', '月福利', '每日礼', '每周礼', '每月礼', '公测抽奖',
		'公测活跃抽奖', '公测登录抽奖', '公测每日抽奖'].indexOf(title) >= 0) {
		itemid = '12011'
	} else if (['分享礼包领取', '分享礼', '领取分享礼'].indexOf(title) >= 0) {
		itemid = '12016'
	} else if (['预约礼', '预约奖励', '不删档预约礼', '不删档预约奖励', '新版本预约礼', '新版本预约奖励', '版本预约礼',
		'版本预约奖励', '周年预约礼', '周年预约奖励', '周年庆预约礼', '周年庆预约奖励'].indexOf(title) >= 0) {
		itemid = '12018'
	}
	report(itemid)
}



// WEBPACK FOOTER //
// ./src/components/actModules/h5/templates/buryingPoint/receive.js